import styled from '@emotion/styled'
export const StyleGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const StyleRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyleHalfCardWrapper = styled.div`
  width: 48.5%;
  border-radius: 12px;
  background: ${(props: any) => props.theme.colors.white};
  padding: 15px;
`

export const StyleFormGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const StyleWorkWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

export const StyleWorkItem = styled.li`
  list-style: disc;
  font-size: 18px;
  margin-left: 15px;
  color: ${(props: any) => props.theme.colors.secondary};
`

export const StyleAddCircle = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 50%;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyleImageRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  column-gap: 15px;
  row-gap: 15px;
`
export const StyleDiscountRow = styled.div`
  display: flex;
`

export const StyleDiscountPercent = styled.div`
  background: ${(props: any) => props.theme.colors.primary};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 40px;
  align-items: center;
  display: flex;
  margin-top: 27px;
  color: white;
  padding: 0px 10px;
  font-size: 16px;
`
